// import logoInvOcenAnalitic from "../../images/investOcenkaAnalitycCenter.svg"

export default function About() {
    return (
        <section className="header">            
            <h1 className="header__title">Калькулятор расчета корректировки на площадь</h1>            
            {/* <p className="header__subtitle">(фактор масштаба)</p> */}
            <p className="header__subtitle">при определении стоимости недвижимости в Центрально-Черноземном регионе</p>
            
            {/* <p className='header__text'>Возможные значения коэффициента торможения:<br /><br />Общественные здания
                и помещения: <br /><strong>-0.19</strong><br />Промышленные, складские и сельскохозяйственные здания,
                помещения: <br /><strong>-0.27</strong><br /><br /> В калькуляторе отрицательное значение коэффициента уже учтено! Вводите цифру без знака "минус"</p> */}
        </section>
    )
};